import Vue from "vue"

function updateBackground(el, binding) {
	if (!binding.value) {
		return
	}
	let gradient = ""
	if (binding.modifiers.gradient) {
		if (binding.modifiers.bottom) {
			gradient =
				"linear-gradient(0deg, rgba(47, 72, 88, 0.85) 0%, rgba(47, 72, 88, 0) 100%) 0% 0% / cover,"
		} else {
			gradient =
				"linear-gradient(0deg, var(--gR-base-90-backdrop) 0%, var(--gR-base-90-backdrop) 100%) 0% 0% / cover,"
		}
	}
	el.style.background = `${gradient}url(${binding.value}) center no-repeat`
	el.style.backgroundSize = "cover"
}

Vue.directive("sk-banner-background", {
	bind: function (el, binding) {
		updateBackground(el, binding)
		el.style.borderRadius = 0
		el.style.width = "100%"
		el.style.height = "24%"
		el.style.maxHeight = "166px"
		el.style.minHeight = "166px"
		el.style.display = "flex"
		el.style.flexDirection = "column"
		el.style.alignItems = "flex-start"
		if (binding.modifiers.bottom) {
			el.style.justifyContent = "flex-end"
		} else {
			el.style.justifyContent = "center"
		}
	},
	update: function (el, binding) {
		updateBackground(el, binding)
	}
})
